import RegistrationLayout from '../shell/layouts/RegistrationLayout.jsx';
import { RequireVerifiedEmail } from '../authentication/RequireVerifiedEmail.jsx';
import { lazyWithRetry } from '../utils/lazyWithRetry.js';

// New 4-step onboarding stepper. createNewUser is called at the end of step 4
// (SDK step). Replaces the old 2-step Registration page at /signup.
const Onboarding = lazyWithRetry(() => import('../pages/public/onboarding/Onboarding.jsx'));

const registrationRoutes = [
    {
        path: '/',
        element: (
            <RequireVerifiedEmail>
                <RegistrationLayout />
            </RequireVerifiedEmail>
        ),
        children: [
            {
                path: 'signup',
                element: <Onboarding />,
            },
            {
                // Explicit alias — both paths land on the same stepper.
                path: 'onboarding',
                element: <Onboarding />,
            },
        ],
    },
];

export default registrationRoutes;
